export default __webpack_public_path__ + "static/media/Evidence.TreatmentHistory..4833007c.png";